import { customInstance } from '@/features/auth/axios-config'
import {
  RequestFilters,
  RequestUserMapping,
  SuccessResponseResponseUserMapping,
} from '@/schema'
import { mergeTablePaginationParams } from '@/utils'

import { UserMappingSource } from '.'

const API_ENDPOINT_USER_MAPPINGS = '/document/v1/teamwork/users'

export const userMappingApi = {
  getListUserMappings: async (
    data: Partial<RequestFilters & { source?: UserMappingSource }> = {}
  ): Promise<SuccessResponseResponseUserMapping> => {
    const requestBody = mergeTablePaginationParams(data)
    requestBody.source = data.source

    return customInstance<SuccessResponseResponseUserMapping>({
      method: 'post',
      url: `${API_ENDPOINT_USER_MAPPINGS}/list`,
      data: requestBody,
    })
  },

  createUserMapping: async (
    payload: Partial<RequestUserMapping>
  ): Promise<SuccessResponseResponseUserMapping> => {
    return customInstance<SuccessResponseResponseUserMapping>({
      method: 'post',
      url: API_ENDPOINT_USER_MAPPINGS,
      data: payload,
    })
  },

  updateUserMapping: async (
    mappingId: string,
    payload: Partial<RequestUserMapping>
  ): Promise<SuccessResponseResponseUserMapping> => {
    return customInstance<SuccessResponseResponseUserMapping>({
      method: 'put',
      url: `${API_ENDPOINT_USER_MAPPINGS}/${mappingId}`,
      data: payload,
    })
  },

  deleteUserMapping: async (mappingId: string): Promise<void> => {
    return customInstance<void>({
      method: 'delete',
      url: `${API_ENDPOINT_USER_MAPPINGS}/${mappingId}`,
    })
  },
}
